import { Tooltip, Box } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

interface ReviewBadgeProps {
  /**
   * Whether to show the badge
   */
  show?: boolean;

  /**
   * Tooltip text
   */
  tooltip?: string;
}

/**
 * Blue info icon to mark fields as important to verify
 * Distinct from certainty indicators (green/yellow/orange/red badges)
 */
export function ReviewBadge({
  show = true,
  tooltip = "Please verify this field carefully",
}: ReviewBadgeProps) {
  if (!show) return null;

  return (
    <Tooltip label={tooltip} position="top" withArrow>
      <Box
        component="span"
        style={{
          display: "inline-flex",
          alignItems: "center",
          cursor: "help",
          verticalAlign: "middle",
        }}
      >
        <IconInfoCircle size={14} color="#228BE6" />
      </Box>
    </Tooltip>
  );
}
